export const TOKEN_KEY = {
  CLIENT_ACCESS_TOKEN_KEY: '20a27bef-4caa-4b01-844f-dd05ccb56810',
  CLIENT_REFRESH_TOKEN_KEY: 'e73501fd-4bd8-4ca3-910a-3855c2ba2e90',
  VENDOR_ACCESS_TOKEN_KEY: '9b285c16-995f-4c9b-b775-a8d194188d47',
  VENDOR_REFRESH_TOKEN_KEY: '8b0fa156-65ec-4cce-ba4b-008dc91d38cf',
  ADMIN_ACCESS_TOKEN_KEY: '0115e0fb-e420-4291-bd1b-7c490b7bb510',
  ADMIN_REFRESH_TOKEN_KEY: '75378d1d-4c39-405c-8d8d-e6fff66ed673',
};
